import HtmlTrans from 'components/shared/HtmlTrans';
import { Heading2 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import TestsFrequency from '../charts/TestsFrequency';
import TestsHiringProcess from '../charts/TestsHiringProcess';
import {
  StyledCardTitle,
  StyledContainer,
  StyledHeader,
  StyledHighlight,
  StyledHighlightValue,
  StyledStagesContent
} from './DurationAndCosts.styled';

const Stages: React.FC = () => {
  const { t } = useI18n('state-of-hiring');

  return (
    <StyledContainer>
      <StyledHeader>
        <Heading2 editorial>{t('state-of-hiring.stages.title')}</Heading2>
      </StyledHeader>
      <StyledStagesContent>
        <div>
          <StyledCardTitle>
            {t('state-of-hiring.stages.tests-number.title')}
          </StyledCardTitle>
          <TestsHiringProcess />
        </div>
        <div>
          <HtmlTrans
            i18nKey="state-of-hiring.stages.tests-number.desc"
            ns="state-of-hiring"
          />
          <StyledHighlight>
            <StyledHighlightValue>3,73</StyledHighlightValue>
            <span>{t('state-of-hiring.stages.tests-number.highlight')}</span>
          </StyledHighlight>
        </div>
      </StyledStagesContent>
      <StyledStagesContent>
        <div>
          <StyledCardTitle>
            {t('state-of-hiring.stages.tests-frequency.title')}
          </StyledCardTitle>
          <TestsFrequency />
        </div>
        <div>
          <HtmlTrans
            i18nKey="state-of-hiring.stages.tests-frequency.desc"
            ns="state-of-hiring"
          />
        </div>
      </StyledStagesContent>
    </StyledContainer>
  );
};

export default Stages;
